import {createContext} from "react";
import {LayoutProps} from "@/Components/Layout";

type LayoutContextProps = {
    props: LayoutProps
}

export const LayoutContext = createContext({} as LayoutContextProps)